export default __webpack_public_path__ + "static/media/download.98916c6e.svg";